var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('appearance-form',{attrs:{"app-client-type-id":_vm.APP_CLIENT_TYPE_BOOKER_TOOLS,"app-client-id":parseInt(_vm.companyId)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }